import { createFileRoute } from '@tanstack/react-router'
import { EditPictureTool } from '~/features/ai-studio/components'

export const Route = createFileRoute('/dashboard/ai-studio/edit-picture')({
  component: EditPictureTool,
})
